import loadProductGroupFredhopperModule from './modules/ProductGroupFredhopper.module';
import loadWishListModule from './modules/WishList.module';
import loadCompareModule from './modules/Compare.module';
import loadDeliveryPromiseModule from './modules/DeliveryPromise.module';
const loadProductGroupFredhopperRootModule = (initialData) => {
    return {
        hasRouter: false,
        modules: [
            loadProductGroupFredhopperModule(initialData),
            loadCompareModule(),
            loadWishListModule(),
            loadDeliveryPromiseModule(),
        ],
    };
};
export default loadProductGroupFredhopperRootModule;
